/**
 * Active-build brand identity. GENERATED from brands/aioverlords.json by scripts/gen-brand-ts.mjs —
 * regenerated by scripts/rebrand.mjs when producing a twin. Components read brand strings from
 * here, never hardcoded, so the rebrand stays a data swap. Colors live in the generated CSS.
 */
export const brand = {
  id: "aioverlords",
  name: "AI Overlords",
  company: "AI Overlords",
  productName: "CreativeEngine",
  tagline: "We ship production systems, not demos.",
  url: "https://aioverlords.io",
  contactUrl: "https://aioverlords.io/contact",
  logoUrl: "/brand-logo.png",
  defaultMode: "light",
  analyticsSite: "demo:creativeengine:aioverlords",
  analyticsEnabled: false,
  version: "v1.1",
  copy: {
    lockedTitle: "This step runs live for clients",
    lockedBody: "This step uses paid AI models and is gated in the public demo. Here's a real sample the platform produced — book a call to run it live on your own inputs.",
    lockedCta: {
      label: "Book a call",
      href: "https://aioverlords.io/contact"
    }
  }
} as const

export type Brand = typeof brand
